import Logger from '@/lib/logger'

export default function(context, inject) {
  inject('logger', Logger)
}
